var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconValuable128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2589_11243)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4144 16.5029H63.8987H89.383C92.3278 16.5029 95.1087 17.8585 96.9227 20.1782L113.212 41.008C115.881 44.4214 115.924 49.2024 113.317 52.6634L71.5837 108.06C68.4029 112.282 62.4017 113.126 58.1796 109.946C57.4683 109.41 56.8353 108.777 56.2989 108.067L14.489 52.6648C11.877 49.2036 11.9181 44.4188 14.5893 41.003L30.8747 20.1782C32.6888 17.8585 35.4696 16.5029 38.4144 16.5029Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85 47.0029H115L114 51.5029L70.399 109.303L64 112.003L67.199 102.903L85 47.0029Z",
    fill: "#FAEC20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4144 16.5029H63.8987H89.383C92.3278 16.5029 95.1087 17.8585 96.9227 20.1782L113.212 41.008C115.881 44.4214 115.924 49.2024 113.317 52.6634L71.5837 108.06C68.4029 112.282 62.4017 113.126 58.1796 109.946C57.4683 109.41 56.8353 108.777 56.2989 108.067L14.489 52.6648C11.877 49.2036 11.9181 44.4188 14.5893 41.003L30.8747 20.1782C32.6888 17.8585 35.4696 16.5029 38.4144 16.5029Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5751 17.3855L82.6347 42.2367C84.3201 44.692 84.7667 47.7919 83.8428 50.623L63.8988 111.738L43.9547 50.623C43.0308 47.7919 43.4774 44.692 45.1628 42.2367L62.2224 17.3855C62.6017 16.8331 63.2287 16.5029 63.8988 16.5029C64.5688 16.5029 65.1959 16.8331 65.5751 17.3855Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0508 46.4131H114.747",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2589_11243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconValuable128);
export default __webpack_public_path__ + "static/media/pictogramBeaconValuable128.c1ef105f3d4dbf6b914bb347366c12b6.svg";
export { ForwardRef as ReactComponent };